var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 时间选择
 * @author (zhanghao14)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import ReactDom from 'react-dom';

import classnames from 'classnames';
import { noop, classPrefix } from '../../common/util';

/**
 * 参数说明
 * className                  可选，自定义样式类名
 * prefixCls                  可选，类名前缀
 * selectIndex                可选，选中的item的位置
 * options                    可选，下拉选项，array类型
 * type                       可选，选择下拉的类型，包括hour，minute，second和am/pm
 * onSelect                   可选，选中时的回调
 * onMouseEnter               可选，鼠标移入时的回调
 */

var Select = function (_Component) {
    _inherits(Select, _Component);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.state = {
            active: false
        };
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        return _this;
    }

    _createClass(Select, [{
        key: 'onSelect',
        value: function onSelect(value) {
            if (this.props.onSelect) {
                this.props.onSelect(value, this.props.type);
            }
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter() {
            this.setState({
                active: true
            });
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            this.setState({
                active: false
            });
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            var _props = this.props,
                options = _props.options,
                selectedIndex = _props.selectedIndex,
                prefixCls = _props.prefixCls;

            var self = this;
            return options.map(function (item, index) {
                var _classnames;

                var className = classnames((_classnames = {}, _defineProperty(_classnames, prefixCls + '-select-item', true), _defineProperty(_classnames, prefixCls + '-select-item-active', index === selectedIndex), _defineProperty(_classnames, prefixCls + '-select-item-disable', item.disabled), _classnames));
                var liProps = {
                    className: className,
                    key: index,
                    onClick: item.disabled ? null : self.onSelect.bind(self, item.value),
                    disabled: item.disabled
                };
                return React.createElement(
                    'li',
                    _extends({}, liProps, { key: index }),
                    item.value
                );
            });
        }
    }, {
        key: 'scrollToSelected',
        value: function scrollToSelected() {
            // move to selected item
            // const select = ReactDom.findDOMNode(this);
            // const list = ReactDom.findDOMNode(this.refs.list);
            var select = this.root;
            var list = this.list;
            if (!list) {
                return;
            }
            var index = this.props.selectedIndex;
            if (index < 0) {
                index = 0;
            }
            var topOption = list.children[index];
            var to = topOption.offsetTop;
            select.scrollTop = to;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scrollToSelected();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.selectedIndex !== this.props.selectedIndex) {
                this.scrollToSelected();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.options.length === 0) {
                return null;
            }

            var containerProps = {
                className: this.props.prefixCls + '-select',
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            };
            return React.createElement(
                'div',
                _extends({}, containerProps, { ref: function ref(el) {
                        return _this2.root = el;
                    } }),
                React.createElement(
                    'ul',
                    { ref: function ref(el) {
                            return _this2.list = el;
                        } },
                    this.getOptions()
                )
            );
        }
    }]);

    return Select;
}(Component);

export default Select;


Select.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    // self
    prefixCls: classPrefix + '-time-picker-select',
    selectedIndex: 0,
    options: [],
    type: '',
    onSelect: noop,
    onMouseEnter: noop
};

Select.propTypes = {
    prefixCls: PropTypes.string,
    options: PropTypes.array,
    selectedIndex: PropTypes.number,
    type: PropTypes.string,
    onSelect: PropTypes.func,
    onMouseEnter: PropTypes.func
};